import Vue from 'vue';

//历史版本顶部入口图标
import SHVersionIcon from './icon/index.js'
Vue.use(SHVersionIcon);


// WEBPACK FOOTER //
// ./src/components/base/view/version/cmps/cmps.js